export default __webpack_public_path__ + "static/media/hdpe-drum-bales-hdpe-cans.95609bec.jpg";